.full-width {
  width: 100%;
}

.popup :global(.ant-select-item-option-disabled) {
  color: var(--rc-theme-color-text-disabled);
}
